import { render, staticRenderFns } from "./ZipRange.vue?vue&type=template&id=1642a140&scoped=true"
import script from "./ZipRange.vue?vue&type=script&lang=js"
export * from "./ZipRange.vue?vue&type=script&lang=js"
import style0 from "./ZipRange.vue?vue&type=style&index=0&id=1642a140&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1642a140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1642a140')) {
      api.createRecord('1642a140', component.options)
    } else {
      api.reload('1642a140', component.options)
    }
    module.hot.accept("./ZipRange.vue?vue&type=template&id=1642a140&scoped=true", function () {
      api.rerender('1642a140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sorting/components/ZipRange.vue"
export default component.exports